import { ReactNode, SVGProps, useId } from 'react';

import { cardStyles, FeaturedIcon, Spec, SpecList, Typography } from '../../ui';
import { formatCurrency } from '@maia/utils';
import { twMerge } from 'tailwind-merge';
import { mapper } from '@maia/icons';
import { BillingUnitDto } from '@maia/shared';

type Props = {
  icon: ReactNode | ((props: SVGProps<SVGSVGElement>) => ReactNode);
  name: string;
  specs: Array<{ icon?: string; title: string; description: string }>;
  showSpecsInCard?: boolean;
  price?: number;
  billingUnit: BillingUnitDto;
};

export function CartItem(props: Props) {
  const id = useId();
  const {
    icon,
    name,
    specs,
    price,
    showSpecsInCard = true,
    billingUnit,
  } = props;

  return (
    <div>
      <div className="flex flex-row items-center gap-x-8">
        <FeaturedIcon icon={icon} size="sm" variant="light-square" />
        <Typography
          variant="body-s"
          weight="semibold"
          className="text-primaryMain"
        >
          {name}
        </Typography>
      </div>

      {specs.length > 0 && (
        <SpecList
          className={twMerge(
            'space-y-8 mt-12',
            showSpecsInCard && cardStyles({ variant: 'outlined' }),
            showSpecsInCard && 'p-12',
          )}
        >
          {specs.map((spec, index) => (
            <Spec
              className="grid grid-cols-2"
              key={`cart-item-${id}-spec-list-item-${index}`}
              title={spec.title}
              icon={spec.icon ? mapper(spec.icon) : undefined}
              value={spec.description}
            />
          ))}
        </SpecList>
      )}

      {typeof price === 'number' && (
        <Typography
          variant="body-xs"
          weight="regular"
          className="mt-8 text-grayscale400"
        >
          <span className="font-semibold text-grayscale600">
            {formatCurrency(price)}
          </span>{' '}
          {billingUnit.label.toLowerCase()}
        </Typography>
      )}
    </div>
  );
}
